module.exports = __webpack_public_path__ + "static/media/22ESCWA7.93f8fb2e.jpg";